<template>
  <div class="w-full">
    <div class="w-full max-display-card">
      <div class="text-center font-bold text-4xl px-10">
        <span>How many are eating?</span>
      </div>
      <transition name="slide-fade1" appear>
        <screen-component-keyboard @setAmount="$emit('personsAmount', $event)"/>
      </transition>
    </div>
    <transition name="slide-fade1" appear>
      <div class="w-full max-display flex justify-center">
        <hans-svg/>
<!--        <img src="../../assets/img/person-2.png" style="width:322px; height: 350px " alt="person"/>-->
      </div>
    </transition>
    <x-footer />
  </div>
</template>
<script>
import XFooter from "@/components/Footer/XFooter";
import ScreenComponentKeyboard from "@/components/ScreenComponents/ScreenComponentKeyboard/ScreenComponentKeyboard";
import HansSvg from "@/components/ImageSvg/HansSvg";

export default {
  name: "PersonAmountComponent",
  components: {
    ScreenComponentKeyboard,
    XFooter,
    HansSvg
  },
};
</script>
